<template>
  <el-table :data="tableData" border style="width: 100%" :maxHeight="maxHeight">
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="type"
      :label="currentPath == 'ROOM_SALES' ? '直播间ID' : '短视频ID'"
      width="120"
      align="center"
    >
      <template slot-scope="{ row }">
        <span>
          {{ currentPath == "ROOM_SALES" ? row.roomId : row.videoId }}</span
        >
      </template>
    </el-table-column>
    <el-table-column
      v-for="item in tableColumnList"
      :key="item.prop"
      :prop="item.prop"
      :label="item.label"
      :min-width="item.minWidth ? item.minWidth : '120'"
      align="center"
    >
      <template slot-scope="{ row }">
        <div
          style="
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            line-height: 27px;
          "
          v-if="
            ['同比', '环比'].includes(row.dateRange) && row[item.prop] !== '-'
          "
        >
          <div>{{ row[item.prop] }}</div>
          <div style="display: flex; align-items: center">
            <span>{{ row[item.prop + "rete"] }}</span>
            <img
              width="20"
              height="20"
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/down.svg"
              alt=""
              v-if="parseFloat(row[item.prop + 'rete']) < 0"
            />
            <img
              width="20"
              height="20"
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/bi/up.svg"
              alt=""
              v-else
            />
          </div>
        </div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="measureUnitId"
      prop="measureUnitSum"
      :label="measureUnitName + '数'"
      width="120"
      align="center"
    >
    </el-table-column>
  </el-table>
</template>

<script>
import Empty from "../../../components/empty.vue";
import mixins from "../../../mixins/index.js";
export default {
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    currentPath: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      measureUnitId: "",
      measureUnitName: "",
      newMeasureUnitName: "",
      tableColumnList: [
        {
          prop: "saleAmount",
          label: "成交金额",
          sortable: true,
        },

        {
          prop: "buyerCount",
          label: "成交人数",
          sortable: true,
        },
        {
          prop: "orderCount",
          label: "成交单量",
          sortable: true,
        },
        {
          prop: "itemCount",
          label: "成交件数",
          sortable: true,
        },
        {
          prop: "customerUnitPrice",
          label: "客单价",
          sortable: true,
        },
        {
          prop: "orderUnitPrice",
          label: "笔单价",
        },
        {
          prop: "itemUnitPrice",
          label: "件单价",
        },
        {
          prop: "avgPurchaseFrequency",
          label: "人均购买频次",
        },
        {
          prop: "avgPurchaseItems",
          label: "人均购买件数",
        },
        {
          prop: "avgItemsPerOrder",
          label: "笔均购买件数",
        },
        {
          prop: "refundAmount",
          label: "退款金额",
          sortable: true,
        },
        {
          prop: "refundCount",
          label: "退款人数",
          sortable: true,
        },
        {
          prop: "refundOrderCount",
          label: "退款单量",
          sortable: true,
        },
        {
          prop: "refundRatioStr",
          label: "退款率",
        },
      ],
    };
  },
  computed: {},
  methods: {},
};
</script>
